$(document).on('click', '.cms-white-world a[data-image-map-marker]', function(event) {
  const url = $(this).attr('href');
  if (url.includes('?')) {
    const whiteWorld = $(this).closest('.cms-white-world');
    const accordion = whiteWorld.find('[data-accordion]');
    if (accordion.length) {
      const id = url.substr(url.indexOf('?') + 1);
      const targetSelector = accordion.find(`#block-${id} [data-tab-content]`);
      if (whiteWorld.find(targetSelector).length) {
        event.preventDefault();
        accordion.foundation('toggle', $(targetSelector));
      }
    }
  }
});
